import qs from 'qs';

const Specialization = {
    namespaced: true,

    state: {
        specializationData: [],
    },

    getters: {
        specializationData (state) {
            return state.specializationData;
        },
    },

    mutations: {

        /**
         * Установить значение специализации
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['specializationData'] = items;
        },

        /**
         * Обновить значение элемента специализации
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['specializationData'][index] = item;
        },

        /**
         * Добавить значение элемента специализации
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['specializationData'].push(item);
        },

        /**
         * Удалить элемент из специализации
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['specializationData'] = state['specializationData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение данных по специализациям
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getSpecializationData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl +  'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.specialization,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по специализациям получены.'),
                        resolve()
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN specialization.js | getSpecializationData : ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по специализациям !'),
                        reject(err);
                });
            })
        },

        /**
         * Сохранение данных по специализациям
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveSpecializationData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.data);
                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.specialization,
                    }),
                }).then(response => {
                    console.log(response.data);
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по специализациям успешно отредактированы!');

                    // Если сохранение нового
                    } else {
                      data.data.specializationId = response.data[0].specializationId;
                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новая специализация успешно создана!');
                    }
                    resolve();
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                        console.log('ERROR IN specialization.js | saveSpecializationData : ' + err);
                        reject(err);
                });
            })
        },

        /**
         * Удаление специализации
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeSpecializationData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.item);
                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.specialization,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Должности успешно удалены!'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении специализации!'),
                    console.log('ERROR IN specialization.js | removeSpecializationData : ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default Specialization;





// WEBPACK FOOTER //
// ./src/store/modules/specialization.js